import type { Comic } from '@/mocks/comics';

export type FilterState = {
  region: string;
  categories: string[];
  status: string;
  sort: string;
  keyword: string;
};

export const defaultFilter: FilterState = {
  region: '全部',
  categories: [],
  status: '全部',
  sort: '综合排序',
  keyword: '',
};

export function filterComics(list: Comic[], filter: FilterState): Comic[] {
  const keyword = filter.keyword.trim().toLowerCase();
  return list.filter((comic) => {
    if (keyword) {
      const hit =
        comic.title.toLowerCase().includes(keyword) ||
        comic.author.toLowerCase().includes(keyword) ||
        comic.tags.some((tag) => tag.toLowerCase().includes(keyword));
      if (!hit) return false;
    }
    if (filter.region !== '全部' && comic.region !== filter.region) return false;
    if (filter.status !== '全部' && comic.status !== filter.status) return false;
    if (filter.categories.length > 0) {
      const matched = comic.categories.some((id) => filter.categories.includes(id));
      if (!matched) return false;
    }
    return true;
  });
}

export function sortComics(list: Comic[], sort: string): Comic[] {
  const result = [...list];
  switch (sort) {
    case '人气最高':
      return result.sort((a, b) => b.views - a.views);
    case '评分最高':
      return result.sort((a, b) => b.rating - a.rating);
    case '更新时间':
      return result.sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
    default:
      return result;
  }
}

export function sortFromQuery(query: string | null): string {
  switch (query) {
    case 'hot':
      return '人气最高';
    case 'new':
      return '更新时间';
    case 'rank':
      return '评分最高';
    default:
      return '综合排序';
  }
}

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)} 万`;
  return String(views);
}